import { HttpEvent } from '@angular/common/http';
import { AgError, JrpcError, JrpcResultError, MethodError, RestError } from './api-error.interface';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type Error = HttpEvent<any> | MethodError;

type ErrorGuards = {
  isJrpcError: (err: Error) => err is JrpcError;
  isJrpcResultError: (err: Error) => err is JrpcResultError;
  isAgError: (err: Error) => err is AgError;
  isRestError: (err: Error) => err is RestError;
};

export const errorGuards: ErrorGuards = {
  isJrpcError: (err: Error): err is JrpcError =>
    ('body' in err && err.body !== null && typeof err.body === 'object' && 'error' in err.body) ||
    ('error' in err &&
      err.error !== null &&
      typeof err.error === 'object' &&
      'jsonrpc' in err.error &&
      'error' in err.error &&
      err.error.error !== null &&
      typeof err.error.error === 'object' &&
      'message' in err.error.error &&
      'code' in err.error.error),

  isJrpcResultError: (err: Error): err is JrpcResultError =>
    'jsonrpc' in err &&
    'result' in err &&
    err.result !== null &&
    typeof err.result === 'object' &&
    'response' in err.result &&
    err.result.response !== null &&
    typeof err.result.response === 'object' &&
    err.result.response.success === false &&
    typeof err.result.response.errorMessage === 'string',

  isAgError: (err: Error): err is AgError =>
    'error' in err &&
    err.error !== null &&
    typeof err.error === 'object' &&
    'code' in err.error &&
    'message' in err.error,

  isRestError: (err: Error): err is RestError =>
    'body' in err &&
    err.body !== null &&
    typeof err.body === 'object' &&
    'Head' in err.body &&
    'Body' in err.body &&
    Array.isArray(err.body.Body.ErrorList),
};

export const isApiError: (error: Error) => error is MethodError = (error: Error): error is MethodError => {
  return (
    error !== null &&
    error !== undefined &&
    typeof error === 'object' &&
    (errorGuards.isRestError(error) ||
      errorGuards.isJrpcError(error) ||
      errorGuards.isJrpcResultError(error) ||
      errorGuards.isAgError(error))
  );
};
